// AUTO GENERATED FILE - Changes WILL be lost.
// ro-RO - used as 'ro' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Bilet",
  "product.last60-row-single": "NBA Ultimele 60 de meciuri unice",
  "product.sb-english-single": "Engleză Soccerbet meci unic",
  "product.sb-italian-single": "Italian Soccerbet Single Match",
  "product.sb-greek-single": "Meci unic fotbal grecesc",
  "product.sb-english-league": "Liga engleză Soccerbet",
  "product.sb-italian-league": "Liga de fotbal italiană",
  "product.sb-greek-league": "Liga de fotbal greacă",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Plasați pariul",
  "betslip.clear": "Curata tot",
  "betslip.clearResult": "Clar",
  "betslip.noSelections": "Adăugați selecții pentru a începe pariurile",
  "betslip.notLoggedIn": "Autentifică-te pentru a începe pariurile",
  "betslip.refresh": "Refresh",
  "betslip.totalStake": "Miză totală",
  "betslip.noHistoryData": "Nu sunt disponibile informații despre pariu",
  "betslip.openBets": "Pariuri deschise",
  "betslip.betHistory": "Istoria pariului",
  "betslip.betHistoryWon": "Câștigat",
  "betslip.betHistoryLost": "Pierdut",
  "loading.loading": "Se încarcă",
  "loading.account": "Se încarcă contul",
  "loading.league": "Se încarcă liga",
  "loading.gameweeks": "Încărcarea săptămânilor de joc",
  "loading.markets": "Încărcarea piețelor",
  "loading.bethistory": "Se încarcă istoricul pariului",
  "login.loginRequired": "Autentificare obligatorie",
  "login.loginToBet": "Vă rugăm să vă autentificați pentru a începe pariurile",
  "navigation.back": "Înapoi",
  "navigation.close": "Închide",
  "video.liveStreamAvailable": "Streaming live disponibil",
  "video.logInToWatch": "Vă rugăm să vă conectați pentru a viziona",
  "error.error": "Eroare",
  "error.404": "Pagina nu a fost găsita",
  "error.gameLaunchFailed": "Imposibil de lansat jocul",
  "error.unknownErrorCode": "Eroare necunoscută: {code}",
  "error.minUnitStakeLimitExceeded": "Miza minimă este {limit}",
  "error.maxUnitStakeLimitExceeded": "Miza maximă este {limit}",
  "error.minTotalStakeLimitExceeded": "Miza totală minimă este {limit}",
  "error.maxTotalStakeLimitExceeded": "Miza totală maximă este {limit}",
  "error.stakeInvalidMultiple": "Miza trebuie să fie un multiplu de {multiple}",
  "error.notPlaced": "Nu este plasat",
  "error.wagerDisallowed": "Pariul a fost anulat",
  "error.errorEventIsOff": "Evenimentul a început",
  "multiplebet.Singles": "Simplu",
  "multiplebet.Doubles": "Dubluri",
  "multiplebet.Trebles": "Treble",
  "multiplebet.Accumulator": "Acumulator",
  "multiplebet.Perm 4-Folds": "Perm 4-ori",
  "multiplebet.Perm 5-Folds": "Perm 5-ori",
  "multiplebet.Perm 6-Folds": "Perm 6-ori",
  "multiplebet.Perm 7-Folds": "Perm 7-ori",
  "multiplebet.Perm 8-Folds": "Perm 8 ori",
  "multiplebet.Perm 9-Folds": "Perm 9-ori",
  "error.excess_bets": "Numărul maxim de meciuri pe bilet este {limit}. Va rog ștergeți o selecție",
  "product.sb-turkish-league": "Liga Turciei",
  "error.minBetslipLimitExceeded": "Suma minimă de pariere este {limit}",
  "error.maxBetslipLimitExceeded": "Suma maximă de pariere este {limit}",
  "error.exceededMaxPayout": "Câștigul maxim potential este {limit} ; vă rugăm micșorați miza",
  "betslip.potentialReturns": "Câștig posibil",
  "betslip.taxDisclaimer": "Toate câștigurile nete sunt impozitate la soluționarea pariului. Valoarea taxei va fi calculată în funcție de câștigurile potențiale ale pariului.",
  "error.maintenanceEnabled": "Serverul este în prezent în curs de mentenanță",
  "error.internalError": "Eroare internă",
  "error.invalidSession": "Sesiunea este invalidă",
  "error.accountDisabled": "Contul este dezactivat",
  "error.invalidPlayerID": "Player ID invalid",
  "error.insufficientBalance": "Fonduri insuficiente",
  "error.configError": "Eroare de configurare",
  "error.betPlaceFailed": "Eroare la plasarea pariului",
  "error.invalidProductID": "ID Produs invalid",
  "error.playerReachedGamingLimits": "Jucătorul a atins limita de pariere responsabil",
  "error.gameCycleDoesNotExist": "Runda nu există",
  "error.betAmountLimitExceeded": "Limita de câștig pentru jucători neverificați a fost depășită",
  "betslip.netStake": "Miza netă",
  "betslip.tax": "Taxă",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATHENS",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "Pariuri inchise",
  "playtime": "Timp de joaca",
  "gameId": "ID-ul jocului",
  "noGames": "Nu sunt jocuri disponibile. Verificați din nou în curând.",
  "Home": "Acasă",
  "Away": "Deplasare",
  "Visitor": "Oaspeți",
  "rules": "Reguli",
  "soccerbet.gameWeek": "SAPTĂMÂNĂ",
  "soccerbet.noGameWeeks": "Nu sunt disponibile săptămâni de joc. Verificați din nou în curând.",
  "soccerbet.league": "Clasamentul Ligii",
  "soccerbet.table.name": "Nume",
  "soccerbet.table.won": "V",
  "soccerbet.table.drawn": "E",
  "soccerbet.table.lost": "Î",
  "soccerbet.table.points": "PT",
  "market.abbr.Both Teams To Score": "GG",
  "market.Both Teams To Score": "Ambele echipe să înscrie",
  "market.Over / Under": "Peste/Sub",
  "market.Double Chance": "Șansă dublă",
  "market.Match Result": "Rezultatul meciului",
  "market.Exact Goals": "Număr goluri exact",
  "market.Correct Score": "Scor corect",
  "market.Match Result Both Score": "Rezultatul meciului & ambele marchează",
  "market.Result Und/Over 1.5 Total Goals": "Rezultat Peste/Sub 1.5 Goluri",
  "market.Result Und/Over 2.5 Total Goals": "Rezultat Peste/Sub 2.5 Goluri",
  "market.Under Over 1.5 Total Goals": "Peste/Sub 1.5 Goluri",
  "market.Under Over 2.5 Total Goals": "Peste/Sub 2.5 Goluri",
  "market.Under Over 3.5 Total Goals": "Peste/Sub 3.5 Goluri",
  "market.Under Over 4.5 Total Goals": "Peste/Sub 4.5 Goluri",
  "market.Total Goals 1 To 2": "Interval total goluri 1-2",
  "market.Total Goals 1 To 3": "Interval total goluri 1-3",
  "market.Total Goals 1 To 4": "Interval total goluri 1-4",
  "market.Total Goals 2 To 3": "Interval total goluri 2-3",
  "market.Total Goals 2 To 4": "Interval total goluri 2-4",
  "market.Under Over 1.5 Home Goals": "Peste/sub 1.5 goluri echipa gazdă",
  "market.Under Over 1.5 Away Goals": "Peste/sub 1.5 goluri echipa oaspete",
  "market.Home Team Exact Goals": "Număr goluri exact ale echipei gazdă",
  "market.Away Team Exact Goals": "Număr goluri exact ale echipei oaspete",
  "selection.Yes": "Da",
  "selection.No": "Nu",
  "selection.1+G": "1&G",
  "selection.1+Ng": "1&Ng",
  "selection.X+G": "X&G",
  "selection.X+Ng": "X&Ng",
  "selection.2+G": "2&G",
  "selection.2+Ng": "2&Ng",
  "selection.1+Yes": "1&Da",
  "selection.1+No": "1&Nu",
  "selection.X+Yes": "X&Da",
  "selection.X+No": "X&Nu",
  "selection.2+Yes": "2&Da",
  "selection.2+No": "2&Nu",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "Sub",
  "selection.O": "Peste",
  "selection.1+O": "1&Peste",
  "selection.X+O": "X&Peste",
  "selection.2+O": "2&Peste",
  "selection.1+U": "1&Sub",
  "selection.X+U": "X&Sub",
  "selection.2+U": "2&Sub",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1X",
  "selection.TID_DRAW_OR_AWAY_WIN": "X2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "PESTE",
  "selection.Under": "SUB",
  "sb-english.team.abbr.ARS": "ARS",
  "sb-english.team.abbr.AST": "AST",
  "sb-english.team.abbr.BHA": "BHA",
  "sb-english.team.abbr.BOU": "BOU",
  "sb-english.team.abbr.BUR": "BUR",
  "sb-english.team.abbr.CHE": "CHE",
  "sb-english.team.abbr.CRY": "CRY",
  "sb-english.team.abbr.EVE": "EVE",
  "sb-english.team.abbr.LEI": "LEI",
  "sb-english.team.abbr.LIV": "LIV",
  "sb-english.team.abbr.MNC": "MNC",
  "sb-english.team.abbr.MNU": "MNU",
  "sb-english.team.abbr.NEW": "NEW",
  "sb-english.team.abbr.SOU": "SOU",
  "sb-english.team.abbr.TOT": "TOT",
  "sb-english.team.abbr.WAT": "WAT",
  "sb-english.team.abbr.WHU": "WHU",
  "sb-english.team.abbr.WOL": "WOL",
  "sb-english.team.abbr.NOR": "NOR",
  "sb-english.team.abbr.SHU": "SHU",
  "sb-english.team.abbr.LEE": "LEE",
  "sb-english.team.abbr.FUL": "FUL",
  "sb-english.team.abbr.WBA": "WBA",
  "sb-italian.team.abbr.MIL": "MIL",
  "sb-italian.team.abbr.ATA": "ATA",
  "sb-italian.team.abbr.BOL": "BOL",
  "sb-italian.team.abbr.BRE": "BRE",
  "sb-italian.team.abbr.CAG": "CAG",
  "sb-italian.team.abbr.CHI": "CHI",
  "sb-italian.team.abbr.FIO": "FIO",
  "sb-italian.team.abbr.GEN": "GEN",
  "sb-italian.team.abbr.INT": "INT",
  "sb-italian.team.abbr.JUV": "JUV",
  "sb-italian.team.abbr.LAZ": "LAZ",
  "sb-italian.team.abbr.NAP": "NAP",
  "sb-italian.team.abbr.ROM": "ROM",
  "sb-italian.team.abbr.SAM": "SAM",
  "sb-italian.team.abbr.UDI": "UDI",
  "sb-italian.team.abbr.VER": "VER",
  "sb-greek.team.abbr.AEK": "AEK",
  "sb-greek.team.abbr.APS": "APS",
  "sb-greek.team.abbr.ARI": "ARI",
  "sb-greek.team.abbr.AST": "AST",
  "sb-greek.team.abbr.ATR": "ATR",
  "sb-greek.team.abbr.GIA": "GIA",
  "sb-greek.team.abbr.LEV": "LEV",
  "sb-greek.team.abbr.OFI": "OFI",
  "sb-greek.team.abbr.OLM": "OLM",
  "sb-greek.team.abbr.PTK": "PTK",
  "sb-greek.team.abbr.PNS": "PNS",
  "sb-greek.team.abbr.PAO": "PAO",
  "sb-greek.team.abbr.PLT": "PLT",
  "sb-greek.team.abbr.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KAIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "ANUNȚ. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "sb-turkish.team.abbr.AKB": "AKB",
  "sb-turkish.team.abbr.BES": "BES",
  "sb-turkish.team.abbr.FEN": "FEN",
  "sb-turkish.team.abbr.GAL": "GAL",
  "sb-turkish.team.abbr.TRA": "TRA",
  "sb-turkish.team.abbr.ANT": "ANT",
  "sb-turkish.team.abbr.GEN": "GEN",
  "sb-turkish.team.abbr.KAS": "KAS",
  "sb-turkish.team.abbr.BUR": "BUR",
  "sb-turkish.team.abbr.KAY": "KAY",
  "sb-turkish.team.abbr.SIV": "SIV",
  "sb-turkish.team.abbr.IBA": "IBA",
  "sb-turkish.team.abbr.HAT": "HAT",
  "sb-turkish.team.abbr.ADS": "ADS",
  "sb-turkish.team.abbr.ALT": "ALT",
  "sb-turkish.team.abbr.GAZ": "GAZ",
  "sb-turkish.team.abbr.GOZ": "GOZ",
  "sb-turkish.team.abbr.KON": "KON",
  "sb-turkish.team.abbr.CRS": "CRS",
  "sb-turkish.team.abbr.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "sb-english.team.abbr.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham Forest",
  "sb-english.team.abbr.NOT": "NOT",
  "market.Overall Winner": "Câștigător general",
  "market.Last60 Winner": "Ultimul 60 Câștigător",
  "market.Both Teams Over 2.5 Last60": "Ambele echipe peste 2.5 Ultimele 60",
  "market.Both Teams Over 3.5 Last60": "Ambele echipe peste 3.5 Ultimii 60",
  "market.First Team To Score In Last60": "Prima echipă care înscrie în ultimii 60",
  "market.Last60 Winner And Winning Margin": "Ultimul 60 câștigător și marjă câștigătoare",
  "market.First To Score 4 Points Last60": "Primul care înscrie 4 puncte Ultimele 60",
  "market.Home Under/Over 4.5 Last60": "{home} peste/sub 4.5 Ultimii 60",
  "market.Visitor Under/Over 4.5 Last60": "{visitor} peste/sub 4.5 Ultimii 60",
  "market.Home Under/Over 5.5 Last60": "{home} peste/sub 5.5 Ultimii 60",
  "market.Visitor Under/Over 5.5 Last60": "{visitor} peste/sub 5.5 Ultimii 60",
  "market.Last60 Winner And O/U 11.5": "Ultimul 60 Câștigător și O/U 11.5",
  "market.Last60 Points Difference": "Diferența ultimilor 60 de puncte",
  "market.Total 3-Pointers Last60": "Total 3 puncte Ultimele 60",
  "selection.Home & 1-3": "{home} & 1-3",
  "selection.Home & 4-6": "{home} & 4-6",
  "selection.Home & 7-9": "{home} & 7-9",
  "selection.Home & 10-12": "{home} & 10-12",
  "selection.Home & 13+": "{home} & 13+",
  "selection.Visitor & 1-3": "{visitor} & 1-3",
  "selection.Visitor & 4-6": "{visitor} & 4-6",
  "selection.Visitor & 7-9": "{visitor} & 7-9",
  "selection.Visitor & 10-12": "{visitor} & 10-12",
  "selection.Visitor & 13+": "{visitor} & 13+",
  "selection.Home & Over": "{home} & Peste",
  "selection.Home & Under": "{home} & Sub",
  "selection.Visitor & Over": "{visitor} & Peste",
  "selection.Visitor & Under": "{visitor} & Sub",
  "last60.team.ATL": "Atlanta Hawks",
  "last60.team.BKN": "Brooklyn Nets",
  "last60.team.BOS": "Boston Celtics",
  "last60.team.CHA": "Charlotte Hornets",
  "last60.team.CHI": "Chicago Bulls",
  "last60.team.CLE": "Cleveland Cavaliers",
  "last60.team.DAL": "Dallas Mavericks",
  "last60.team.DEN": "Denver Nuggets",
  "last60.team.DET": "Detroit Pistons",
  "last60.team.GSW": "Golden State Warriors",
  "last60.team.HOU": "Houston Rockets",
  "last60.team.IND": "Indiana Pacers",
  "last60.team.LAC": "LA Clippers",
  "last60.team.LAL": "Los Angeles Lakers",
  "last60.team.MEM": "Memphis Grizzlies",
  "last60.team.MIA": "Miami Heat",
  "last60.team.MIL": "Milwaukee Bucks",
  "last60.team.MIN": "Minnesota Timberwolves",
  "last60.team.NOP": "New Orleans Pelicans",
  "last60.team.NYK": "New York Nicks",
  "last60.team.OKC": "Oklahoma City Thunder",
  "last60.team.ORL": "Orlando Magic",
  "last60.team.PHI": "Philadelphia 76ers",
  "last60.team.PHX": "Phoenix Suns",
  "last60.team.POR": "Portland Trail Blazers",
  "last60.team.SAC": "Sacramento Kings",
  "last60.team.SAS": "San Antonio Spurs",
  "last60.team.TOR": "Toronto Raptors",
  "last60.team.UTA": "Utah Jazz",
  "last60.team.WAS": "Washington Wizards",
  "last60.team.abbr.ATL": "ATL",
  "last60.team.abbr.BKN": "BKN",
  "last60.team.abbr.BOS": "BOS",
  "last60.team.abbr.CHA": "CHA",
  "last60.team.abbr.CHI": "CHI",
  "last60.team.abbr.CLE": "CLE",
  "last60.team.abbr.DAL": "DAL",
  "last60.team.abbr.DEN": "DEN",
  "last60.team.abbr.DET": "DET",
  "last60.team.abbr.GSW": "GSW",
  "last60.team.abbr.HOU": "HOU",
  "last60.team.abbr.IND": "IND",
  "last60.team.abbr.LAC": "LAC",
  "last60.team.abbr.LAL": "LAL",
  "last60.team.abbr.MEM": "MEM",
  "last60.team.abbr.MIA": "MIA",
  "last60.team.abbr.MIL": "MIL",
  "last60.team.abbr.MIN": "MIN",
  "last60.team.abbr.NOP": "NOP",
  "last60.team.abbr.NYK": "NYK",
  "last60.team.abbr.OKC": "OKC",
  "last60.team.abbr.ORL": "ORL",
  "last60.team.abbr.PHI": "PHI",
  "last60.team.abbr.PHX": "PHX",
  "last60.team.abbr.POR": "POR",
  "last60.team.abbr.SAC": "SAC",
  "last60.team.abbr.SAS": "SAS",
  "last60.team.abbr.TOR": "TOR",
  "last60.team.abbr.UTA": "UTA",
  "last60.team.abbr.WAS": "WAS",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}",
  "market.Total 3-Pointers Last60 1-6": "Total coșuri de 3 puncte Ultimele 60",
  "market.Last60 Winning Margin 1": "Ultimele 60 Diferență de scor",
  "market.Last60 Winning Margin 2": "Ultimele 60 Diferență de scor",
  "market.Last60 Winning Margin 3": "Ultimele 60 Diferență de scor",
  "market.Last60 Winner & Winning Margin 1": "Ultimele 60 Câștigător & Diferență de scor",
  "market.Last60 Winner & Winning Margin 2": "Ultimele 60 Câștigător & Diferență de scor",
  "market.Last60 Winner & Winning Margin 3": "Ultimele 60 Câștigător & Diferență de scor",
  "market.Total 3-Pointers Last60 1-3+": "Total coșuri de 3 puncte Ultimele 60",
  "selection.Home & 1": "{home} & 1",
  "selection.Home & 2": "{home} & 2",
  "selection.Home & 3": "{home} & 3",
  "selection.Home & 4": "{home} & 4",
  "selection.Home & 5": "{home} & 5",
  "selection.Home & 6": "{home} & 6",
  "selection.Home & 7": "{home} & 7",
  "selection.Home & 8": "{home} & 8",
  "selection.Home & 9": "{home} & 9",
  "selection.Home & 10": "{home} & 10",
  "selection.Home & 11": "{home} & 11",
  "selection.Home & 12": "{home} & 12",
  "selection.Home & 13": "{home} & 13",
  "selection.Home & 14": "{home} & 14",
  "selection.Home & 15": "{home} & 15",
  "selection.Home & 16": "{home} & 16",
  "selection.Home & 17+": "{home} & 17+",
  "selection.Visitor & 1": "{visitor} & 1",
  "selection.Visitor & 2": "{visitor} & 2",
  "selection.Visitor & 3": "{visitor} & 3",
  "selection.Visitor & 4": "{visitor} & 4",
  "selection.Visitor & 5": "{visitor} & 5",
  "selection.Visitor & 6": "{visitor} & 6",
  "selection.Visitor & 7": "{visitor} & 7",
  "selection.Visitor & 8": "{visitor} & 8",
  "selection.Visitor & 9": "{visitor} & 9",
  "selection.Visitor & 10": "{visitor} & 10",
  "selection.Visitor & 11": "{visitor} & 11",
  "selection.Visitor & 12": "{visitor} & 12",
  "selection.Visitor & 13": "{visitor} & 13",
  "selection.Visitor & 14": "{visitor} & 14",
  "selection.Visitor & 15": "{visitor} & 15",
  "selection.Visitor & 16": "{visitor} & 16",
  "selection.Visitor & 17+": "{visitor} & 17+",
  "selection.Home & 1-2": "{home} & 1-2",
  "selection.Home & 3-4": "{home} & 3-4",
  "selection.Home & 5-6": "{home} & 5-6",
  "selection.Home & 7-8": "{home} & 7-8",
  "selection.Home & 9-10": "{home} & 9-10",
  "selection.Home & 11-12": "{home} & 11-12",
  "selection.Home & 13-14": "{home} & 13-14",
  "selection.Home & 15-16": "{home} & 15-16",
  "selection.Visitor & 1-2": "{visitor} & 1-2",
  "selection.Visitor & 3-4": "{visitor} & 3-4",
  "selection.Visitor & 5-6": "{visitor} & 5-6",
  "selection.Visitor & 7-8": "{visitor} & 7-8",
  "selection.Visitor & 9-10": "{visitor} & 9-10",
  "selection.Visitor & 11-12": "{visitor} & 11-12",
  "selection.Visitor & 13-14": "{visitor} & 13-14",
  "selection.Visitor & 15-16": "{visitor} & 15-16"
}
